import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Plug, FolderGit2, Workflow, ShieldCheck, ArrowRight, GitBranch } from "lucide-react";

function Stat({ icon: Icon, label, value, tid }) {
  return (
    <div data-testid={tid} className="border border-line bg-surface p-6 hover:-translate-y-1 hover:shadow-[4px_4px_0px_#39FF14] transition-all duration-150">
      <Icon className="text-acid mb-4" size={22} />
      <div className="text-4xl font-black tracking-tighter">{value}</div>
      <div className="text-xs uppercase tracking-widest text-zinc-400 mt-1">{label}</div>
    </div>
  );
}

export default function Dashboard() {
  const [conns, setConns] = useState([]);
  const [pipelines, setPipelines] = useState([]);

  useEffect(() => {
    api.get("/connections").then((r) => setConns(r.data)).catch(() => {});
    api.get("/pipelines").then((r) => setPipelines(r.data.pipelines)).catch(() => {});
  }, []);

  const committed = pipelines.filter((p) => p.status === "committed").length;

  return (
    <div className="p-8 fadeup">
      <div className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-400 mb-1">Control Room</div>
      <h1 className="text-4xl font-black tracking-tighter mb-8">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-10">
        <Stat icon={Plug} label="Conexões" value={conns.length} tid="stat-connections" />
        <Stat icon={Workflow} label="Pipelines" value={pipelines.length} tid="stat-pipelines" />
        <Stat icon={ShieldCheck} label="Publicadas" value={committed} tid="stat-committed" />
        <Stat icon={GitBranch} label="Provedores" value={new Set(conns.map((c) => c.provider)).size} tid="stat-providers" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="border border-line bg-surface p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold tracking-tight">Começar</h2>
          </div>
          <div className="space-y-3">
            <Link to="/app/connections" data-testid="quick-connect" className="flex items-center justify-between border border-line px-4 py-3 hover:border-acid hover:text-acid transition-colors">
              <span className="flex items-center gap-3"><Plug size={16} /> Conectar GitHub / GitLab / Azure DevOps</span>
              <ArrowRight size={16} />
            </Link>
            <Link to="/app/repositories" data-testid="quick-repos" className="flex items-center justify-between border border-line px-4 py-3 hover:border-acid hover:text-acid transition-colors">
              <span className="flex items-center gap-3"><FolderGit2 size={16} /> Selecionar repositório</span>
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>

        <div className="border border-line bg-surface p-6">
          <h2 className="text-lg font-bold tracking-tight mb-4">Pipelines recentes</h2>
          {pipelines.length === 0 ? (
            <div className="text-sm text-zinc-400 font-mono border border-dashed border-line p-6 text-center">
              &gt; nenhuma pipeline ainda_
            </div>
          ) : (
            <div className="space-y-2">
              {pipelines.slice(0, 5).map((p) => (
                <Link key={p.id} to={`/app/pipelines/${p.id}`} data-testid={`recent-${p.id}`}
                  className="flex items-center justify-between border border-line px-4 py-3 hover:border-acid transition-colors">
                  <span className="truncate text-sm">{p.repo_full_name}</span>
                  <span className={`text-xs uppercase tracking-widest border px-2 py-0.5 ${p.status === "committed" ? "border-acid text-acid" : "border-zinc-600 text-zinc-400"}`}>{p.status}</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
